import { RECEIVE_WELCOME_CENTER_DOC } from '../constants/ActionTypes';

const welcomeCenterDoc = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_WELCOME_CENTER_DOC:
      return action.welcomeCenterDoc;
    default:
      return state;
  }
};

export default welcomeCenterDoc;
